export const useCategoryAncestorsChapter = (
  pAncestors: CategorySchema[] | Ref<CategorySchema[]>,
  breadcrumbLinks: Links = null
) => {
  const ancestors = toValue(pAncestors);

  const chapter = computed(() => {
    const chapter = ancestors.find(
      (link) => link.contentType === ContentTypes.Chapter
    );
    return chapter;
  });

  const link = computed(() => {
    if (!breadcrumbLinks) return null;
    if (!chapter.value) return null;
    const link = breadcrumbLinks.find((link) => link.id === chapter.value.id);
    return link;
  });

  const defaultLink = computed(() => {
    if (!breadcrumbLinks) return null;
    return breadcrumbLinks.length
      ? breadcrumbLinks[0]
      : { label: 'Accueil', url: '/' };
  });

  return {
    chapter,
    link,
    defaultLink,
  };
};
